export const round = (num, places) => {
  if (typeof num !== "number") return "-";
  return +(Math.round(num + "e+" + places) + "e-" + places);
};

// Use regular expressions to check if a string contains a number
// Checks for floats and integers
export const stringContainsNumber = (str) => {
  const regexFloat = /[-+]?\d*\.\d+/;
  const regexInteger = /[-+]?\b\d+\b/;
  return regexFloat.test(str) || regexInteger.test(str);
};

export const getDecimalNum = (inputValue, decimalPlaces = 2) => {
  const isNumber =
    typeof inputValue === "number" && typeof decimalPlaces === "number";
  const isNumberString =
    typeof inputValue === "string" &&
    stringContainsNumber(inputValue) &&
    typeof decimalPlaces === "number";

  if (isNumber || isNumberString) {
    return Number(inputValue).toFixed(decimalPlaces);
  } else {
    return inputValue;
  }
};
